var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('iw-input-checkbox',{staticClass:"field",attrs:{"input-label":_vm.$t('intercom'),"name":"has-intercom"},model:{value:(_vm.hasIntercom),callback:function ($$v) {_vm.hasIntercom=$$v},expression:"hasIntercom"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }